import React from 'react';
import IcehockeyComp from './Icehockey.component';

class Icehockey extends React.Component {
    componentDidMount() {
        IcehockeyComp();
    }
    render() {
        return (
            <div>
            </div>
        )
    }
}

export default Icehockey;